import styled from 'styled-components';
import { colours } from '@storefront/lib-global/stylings';

export const CrossedLine = styled.hr`
  border: none;
  border-top: 1px solid ${colours.GREY};
  left: 50%;
  position: absolute;
  transform-origin: center;
`;
